import { useEffect, useState } from "react"
import useHttp from "../../../../hooks/use-http"
import ReservationPrice from "./ReservationPrice/ReservationPrice"
import KeyValueTable from "../../../../UI/KeyValueTable/KeyValueTable"
import { euroFormatter } from "../../../../functions/Formatters/formatters"
import i18n from "../../../../i18n"
import { isValidUUID } from "../../../../functions/checkType"
import { pushToDataLayer } from "../../../../functions/pushToDataLayer"

const ReservationConfirmed = ({ initialReservation = null }) => {
    const [reservationData, setReservationData] = useState(initialReservation)
    const {isLoading : getFormLoading, error : getFormError, sendRequest : getData} = useHttp((data) => {setReservationData(data);})

    useEffect(() => {
        reservationData && pushToDataLayer({
            event: "purchase",
            transaction_id: reservationData.reservation_number,
            value: reservationData.total_amount_in_vat,
            currency: "EUR",
            items: (reservationData.reservationline_objects || reservationData.lines || []).map((line) => ({
                item_id: line.product_object?.product_number,
                item_name: line.description,
                price: line.unit_amount ?? line.amount_in_vat,
                quantity: line.quantity
            })),
            // custom (report via custom dimensions)
            start_time: reservationData.from_time,
            end_time: reservationData.to_time,
            guests: reservationData.people
        })
    }, [reservationData])

    useEffect(() => {  
        if (initialReservation) return
        var uuid = ''
        if(isValidUUID(window.location.pathname.split('/')[3])){
            uuid = window.location.pathname.split('/')[3]
        }
        else{
            uuid = window.location.pathname.split('/')[4]
        }
        getData({url:'/rest/reservation/'+uuid+'/retrieve_store/', json:true})
    }, [initialReservation])  

    if(!reservationData){
        return <div></div>
    }
    const table_fields = {'full_name': i18n.t('Naam'),'company': i18n.t('Bedrijf'),'people': i18n.t('Aantal mensen'),'email': i18n.t('Email'),'phone': i18n.t('Telefoon')}
    const addition_fields = <>
        <tr>
            <td>{i18n.t('Status')}</td>
            <td>{reservationData.status_object?.status}</td>
        </tr>
        {reservationData.payment_method_object &&
        <tr>
            <td>{i18n.t('Payment method')}</td>
            <td>{reservationData.payment_method_object.name}</td>
        </tr>
        }
        <tr>
            <td>{i18n.t('Betaald bedrag')}</td>
            <td>{euroFormatter(reservationData.paid_amount)}</td>
        </tr>
    </> 

    return <div className="container">
        <div className="row w-100 my-4">
            <div className="col-12 col-md-10 mx-auto">
                <h5>{i18n.t('Reserveringdetails')}</h5>
                <KeyValueTable original={reservationData} allowed={table_fields} >
                    {addition_fields}
                </KeyValueTable>
                <ReservationPrice data={reservationData}/>
            </div>
        </div>
    </div>
}

export default ReservationConfirmed